<script>
import { mapState, mapActions } from "vuex";
import styles from "../subMenu/subMenu.module.scss";
import { animate } from "../common/js/animate";
import classnames from "classnames";
export default {
  name: "submenu",
  data() {
    return {
      menu: [],
      arrowStatus: true,
      fade: "fade",
    };
  },
  computed: {
    ...mapState({
      list: (state) => state.menu.subMenuList,
      currentSubMenu: (state) => state.menu.currentSubMenu,
      currentMovePlace: (state) => state.menu.currentMovePlace,
    }),
  },
  mounted() {
    this.list.map((item) => {
      if (item.show) {
        const childrenMenu = item.children;
        this.$nextTick(function() {
          this.initMovePlace(childrenMenu);
        });
      }
    });
  },
  methods: {
    ...mapActions("menu", [
      "setSubmenuList",
      "setCurrentSubMenu",
      "setCurrentMovePlace",
    ]),
    onFirstMenuClick(e, item) {
      const list = JSON.parse(JSON.stringify(this.list)).map((f, index) => {
        if (f.id === item.id) {
          f.show = !f.show;
        } else {
          f.show = false;
        }
        return f;
      });
      this.setSubmenuList(list);
    },
    onMenuClick(e, item) {
      e.stopPropagation();
      this.menu = Array.from(document.querySelectorAll(".menu-second"));
      const index = this.menu.findIndex((f) => f.dataset.menuId === item.id);
      const distance = index * 58;
      const moveDom = document.querySelector(".top-move");
      moveDom.classList.remove(styles["init-top-move"]);
      this.setCurrentMovePlace({ place: distance });
      const correntId = item.id;
      const tempList = (function deep(list) {
        return list.map((item) => {
          const len = item.children.length;
          if (len > 0) {
            deep(item.children);
          } else {
            const currentStatus = correntId === item.id;
            item.current = currentStatus;
          }
          return item;
        });
      })(JSON.parse(JSON.stringify(this.list)));
      this.setSubmenuList(tempList);
      this.$router.push(item.href);
    },
    onMenuOver(e) {
      const el = e.target;
      el.classList.add(styles.active);
    },
    onMenuOut(e) {
      const el = e.target;
      el.classList.remove(styles.active);
    },
    initMovePlace(list) {
      const menu = list.some((item) => item.current);
      this.$nextTick(function() {
        const moveDom = document.querySelector(".top-move");
        moveDom.classList.add(styles["init-top-move"]);
        if (menu) {
          moveDom.classList.remove(styles["init-top-move"]);
          const distance = this.currentMovePlace.place;
          animate(moveDom, distance, "top");
        }
      });
    },
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        newVal.map((item) => {
          if (item.show) {
            const childrenMenu = item.children;
            this.$nextTick(function() {
              this.initMovePlace(childrenMenu);
            });
          }
        });
      },
      deep: true,
    },
  },
  render() {
    const { list, arrowStatus, fade } = this;
    const {
      indent,
      onMenuClick,
      onMenuOver,
      onMenuOut,
      onFirstMenuClick,
      onFirstMenuItemClick,
    } = this;
    const rnederArrow = (state) =>
      state ? (
        <img src={require("@/assets/images/menu_img/arrow_down.png")} />
      ) : (
        <img src={require("@/assets/images/menu_img/arrow_right.png")} />
      );
    const rnederSubMenu = (status, list) =>
      status ? (
        <ul class={styles["sub-list"]}>
          <span class={[styles["top-move"], "top-move"].join(" ")}></span>
        
           {renderTrrNode(list)}
        
         
        </ul>
      ) : (
        <ul />
      );
    // const rnederMoveSpan = list => {
    //   const s = list.some(item => item.children.length === 0);
    //   return s ? (
    //     <span class={[styles["top-move"], "top-move"].join(" ")}></span>
    //   ) : (
    //     <span />
    //   );
    // };
    const renderTrrNode = (data) => {
      return data.map((item) => {
        const children = item.children.length > 0;
        const d = item.show;
        if (children) {
          return (
            <li
              data-id={item.id}
              onClick={(e) => onFirstMenuClick(e, item)}
              class={classnames(
                { [styles["menu-first-bg"]]: item.show },
                styles["menu-first"]
              )}
            >
              <span
                data-menu-id={item.id}
                onMouseover={onMenuOver}
                onMouseout={onMenuOut}
                class={classnames([styles["menu-top"], styles["menu-list"]])}
              >
                {item.title}
                <span class={styles.arrow}>{rnederArrow(item.show)}</span>
              </span>

              {rnederSubMenu(item.show, item.children)}
            </li>
          );
        } else {
          return (
            <li
              data-menu-id={item.id}
              onClick={(e) => onMenuClick(e, item)}
              onMouseover={onMenuOver}
              onMouseout={onMenuOut}
              class={[
                styles["menu-list"],
                styles["menu-second"],
                "menu-list",
                "menu-second",
              ].join(" ")}
            >
              {item.title}
            </li>
          );
        }
      });
    };
    return (
      <ul class={styles["sub-menu"]}>
        {/*{rnederMoveSpan(list)}*/}
        {renderTrrNode(list)}
      </ul>
    );
  },
};
</script>
<style>
/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
